export const Appearance = {
  getColorScheme: () => undefined
};
